import { Controller } from 'stimulus';
import Swiper, { Autoplay } from 'swiper';

Swiper.use([Autoplay]);

export default class extends Controller {

  initialize() {
    this.swiper = new Swiper(this.element, {
      speed: 500,
      spaceBetween: 15,
      autoplay: {
        delay: 6000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      },
      autoHeight: true,
      loop: true,
      allowTouchMove: false,
    });
  }

  connect() {
    console.log('hello preview');
  }
}

